import { render, staticRenderFns } from "./appointDetail.vue?vue&type=template&id=1974a258&scoped=true"
import script from "./appointDetail.vue?vue&type=script&lang=js"
export * from "./appointDetail.vue?vue&type=script&lang=js"
import style0 from "./appointDetail.vue?vue&type=style&index=0&id=1974a258&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1974a258",
  null
  
)

export default component.exports